<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="report.title" v-if="report.title" />
    </template>

    <div class="css-v2 grid-report">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="report.dataSourceConfig"
        :columns="columns"
        :title="report.title"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { ScreenLayoutService } from "../_services/api/reports/screen-layout.service";
import { CommonStorage } from "../_services/storage";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      backButtonRoute: `/reports/${this.$route.params.category}`,
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      persistenceKey: undefined,
    };
  },
  computed: {
    columns() {
      var cols = this.report.columns;

      return cols;
    },
  },

  async created() {
    await this.$store.dispatch("defaultDateSettings/setCurrentFiscalData");
    this.persistenceKey = this.$route.params.reportroute;
    let response = await ScreenLayoutService.getByRoute(
      this.$route.params.reportroute
    );

    if (response.data.value) {
      var report = JSON.parse(response.data.value[0].Definition);
      // if (DataGridState.isAvailable(this.persistenceKey)) {
      //   let dbResponse = JSON.parse(response.data.value[0].Definition);
      //   report = await DataGridState.readStoredState(
      //     this.persistenceKey,
      //     dbResponse
      //   );
      // } else {
      //   report = JSON.parse(response.data.value[0].Definition);
      // }

      var url = window.location.href;
      if (url.indexOf("?") != -1) {
        if (Object.keys(this.baseView.query).length != 0) {
          CommonStorage.clear("filter-panel-" + this.persistenceKey);
          CommonStorage.clear(this.persistenceKey);
          report.columns.forEach((element) => {
            if (element.filterDefaultValue != undefined)
              element.filterDefaultValue = undefined;

            if (this.baseView.query[element.screenField] != undefined)
              element.filterDefaultValue = JSON.parse(
                this.baseView.query[element.screenField]
              );
          });
        }
      }
      this.report = report;
    }
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
  },
};
</script>
